import React, { Fragment, useEffect, useState } from "react";
import Header from "../../Components/Layout/Header";
import styles from "./Memorabilia.module.css";
import { Fade } from "react-slideshow-image";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import {
  Backdrop,
  Box,
  Container,
  FormControl,
  Grid,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
  styled,
  Typography,
} from "@mui/material";
import enland from "../../Assets/memorabilia/Vertical-Seporation1.webp";
import collage from "../../Assets/memorabilia/photo-collage5.webp";
import cmc from "../../Assets/memorabilia/GUNNAR AiOX cutting nested layout(720p)1 (2).mp4";
import ClearIcon from "@mui/icons-material/Clear";
import Parse from "../../API/ParseServer";
import CaseStudyTab from "../../Components/Tabs/CaseStudyTab";
import MemorabiliaAlbumTab from "../../Components/Tabs/MemorabiliaAlbumTab";
import { Slide } from "react-slideshow-image";
import collageLight from "../../Assets/memorabilia/photo-collage-light.jpg";
import footballTeams from "../../Assets/memorabilia/UK-English-foortball-teams.png";
import rugbyTeams from "../../Assets/memorabilia/UK-English-rugby-teams.png";
import Album from "../../Components/Album/Album";
import Footer from "../../Components/Layout/Footer";
import { motion } from "motion/react";

const indicators = (index: any) => <li className={styles.indicator}></li>;
const properties = {
  prevArrow: <ArrowBackIosRoundedIcon className={styles.arrow} />,
  nextArrow: <ArrowForwardIosRoundedIcon className={styles.arrow} />,
};

const CustomeSelect = styled(Select)(({ theme }) => ({
  color: "black",
  marginTop: "5px",
  borderRadius: "7px",
  outline: "none",
  // borderColor: "#863a18",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "gray !important",
    padding: "5px 10px",
    outline: "none",
  },
  "& .MuiSelect-select": {
    padding: "10px",
    fontSize: "16px",
  },
}));
const Memorabilia = () => {
  const [modal, setModal] = React.useState("");
  const handleClose = () => {
    setModal("");
  };
  const handleOpen = (event: any) => {
    setModal(event.target.id);
  };
  const [name, setName] = useState("");
  const [company, setCompany] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [details, setDetails] = useState("");
  const [memorabiliaType, setMemorabiliaType] = React.useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [military, setMilitary] = useState<any>();
  const [militaryArray, setMilitaryArray] = useState<number[]>([]);

  useEffect(() => {
    const fetchAlbum = async () => {
      const query = new Parse.Query("Album");

      try {
        const results = await query.find();
        // setTopics(results);
        results.forEach((album: any) => {
          if (album.get("type") === "Military") {
            setMilitary(album);
            console.log(album.get("counter"));
            for (let i = 1; i <= album.get("counter"); i++) {
              setMilitaryArray((cur: number[]) => {
                if (!cur.find((num: any) => num === i)) return [...cur, i];
                else return cur;
              });
            }
          }
        });
        // console.log(results);
      } catch (err: any) {
        setErrorMessage(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAlbum();
  }, []);
  const [slider, setSlider] = useState<any>();
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSlider = async () => {
      const query = new Parse.Query("Slider");
      query.equalTo("page", "memorabilia");
      try {
        const results = await query.find();
        if (results.length > 0) {
          console.log(results);
          setSlider(results);
        } else {
          throw new Error("Slider not found.");
        }
      } catch (err: any) {
        setErrorMessage(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSlider();
  }, []);
  const validEmail =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const validMobile =
    /^(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}$/;
  const formSubmitHandler = async (event: any) => {
    event.preventDefault();
    switch (modal) {
      case "CMC Project":
        if (!(email && name && mobile && details))
          setErrorMessage("Please fill in every required field");
        else if (!validEmail.test(String(email)))
          setErrorMessage("Invalid email address");
        else if (!validMobile.test(String(mobile)))
          setErrorMessage("Invalid phone number");
        else {
          setLoading(true);
          setErrorMessage("");
          setSuccess(false);

          try {
            // Create a new instance of the "Form" class
            const Form = Parse.Object.extend("Form");
            const form = new Form();

            // Set the form data
            form.set("type", "CMC Project");
            form.set("userName", name);
            form.set("userEmail", email);
            form.set("userMobile", mobile);
            form.set("company", company);
            form.set("details", details);
            form.set("status", "new");

            // Save the form data to Parse Server
            await form.save();
            setName("");
            setCompany("");
            setEmail("");
            setMobile("");
            setDetails("");
            setMemorabiliaType([]);
            setErrorMessage("Your information has been successfully submitted");
          } catch (error: any) {
            console.error("Error submitting form:", error);
            setErrorMessage(error.message);
          } finally {
            setLoading(false);
            // setModal("");
          }
        }
        break;
      case "Chat":
        if (!(email && name && mobile && details && company))
          setErrorMessage("Please fill in every required field");
        else if (!validEmail.test(String(email)))
          setErrorMessage("Invalid email address");
        else if (!validMobile.test(String(mobile)))
          setErrorMessage("Invalid phone number");
        else {
          setLoading(true);
          setErrorMessage("");
          setSuccess(false);

          try {
            // Create a new instance of the "Form" class
            const Form = Parse.Object.extend("Form");
            const form = new Form();

            // Set the form data
            form.set("type", "Chat");
            form.set("userName", name);
            form.set("userEmail", email);
            form.set("userMobile", mobile);
            form.set("company", company);
            form.set("details", details);
            form.set("status", "new");

            // Save the form data to Parse Server
            await form.save();
            setName("");
            setCompany("");
            setEmail("");
            setMobile("");
            setDetails("");
            setMemorabiliaType([]);
            setErrorMessage("Your information has been successfully submitted");
          } catch (error: any) {
            console.error("Error submitting form:", error);
            setErrorMessage(error.message);
          } finally {
            setLoading(false);
            // setModal("");
          }
        }
        break;
      default:
        if (!(email && name && mobile && details && memorabiliaType))
          setErrorMessage("Please fill in every required field");
        else if (!validEmail.test(String(email)))
          setErrorMessage("Invalid email address");
        else if (!validMobile.test(String(mobile)))
          setErrorMessage("Invalid phone number");
        else {
          setLoading(true);
          setErrorMessage("");
          setSuccess(false);

          try {
            // Create a new instance of the "Form" class
            const Form = Parse.Object.extend("Form");
            const form = new Form();

            // Set the form data
            form.set("type", "Journey");
            form.set("userName", name);
            form.set("userEmail", email);
            form.set("userMobile", mobile);
            form.set("company", company);
            form.set("details", details);
            form.set("memorabiliaType", memorabiliaType);
            form.set("status", "new");

            // Save the form data to Parse Server
            await form.save();
            setName("");
            setCompany("");
            setEmail("");
            setMobile("");
            setDetails("");
            setMemorabiliaType([]);
            setErrorMessage("Your information has been successfully submitted");
          } catch (error: any) {
            console.error("Error submitting form:", error);
            setErrorMessage(error.message);
          } finally {
            setLoading(false);
            // setModal("");
          }
        }
        break;
    }
  };
  const formResetHandler = () => {
    // setModal("");
    setName("");
    setCompany("");
    setEmail("");
    setMobile("");
    setDetails("");
    setMemorabiliaType([]);
    setErrorMessage("");
  };
  const nameChangeHandler = (event: any) => {
    setName(event.target.value);
  };
  const companyChangeHandler = (event: any) => {
    setCompany(event.target.value);
  };
  const emailChangeHandler = (event: any) => {
    setEmail(event.target.value);
  };
  const mobileChangeHandler = (event: any) => {
    setMobile(event.target.value);
  };
  const detailsChangeHandler = (event: any) => {
    setDetails(event.target.value);
  };
  const memorabiliaTypeChangeHandler = (event: any) => {
    setMemorabiliaType(event.target.value);
  };
  const textVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut", delay: 0.2 },
    },
  };
  const shirtVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut", delay: 0.5 },
    },
  };
  const scaleVariants = {
    hidden: { opacity: 0, scale: 0.5 },
    visible: (custom: any) => ({
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5, ease: "easeOut", delay: 0.2 * custom },
    }),
  };
  return (
    <Fragment>
      <Backdrop
        sx={(theme) => ({
          color: "#fff",
          zIndex: theme.zIndex.drawer + 1,
        })}
        open={modal === "" ? false : true}
        // onClick={handleClose}
      >
        {modal === "CMC Project" ? (
          <Grid
            sx={{
              backgroundColor: "white",
              width: { xs: "95vw", sm: "38rem" },
              height: { xs: "46rem", sm: "40rem" },
              display: "flex",
              justifyContent: "space-between",
              // alignItems: "center",
              color: "black",
              py: { sm: 5, xs: 2 },
              px: { sm: 8, xs: 4 },
              position: "relative",
            }}
            container
          >
            <button
              style={{
                position: "absolute",
                right: "3rem",
                backgroundColor: "transparent",
                border: "none",
                cursor: "pointer",
                top: "3rem",
              }}
              onClick={handleClose}
            >
              <ClearIcon />
            </button>
            <Grid item xs={12}>
              <Typography component="h2" variant="h4">
                Get in touch
              </Typography>
            </Grid>
            <Grid item md={5.5} xs={12}>
              <label htmlFor="name">Full Name*</label>
              <input
                className={styles.input}
                placeholder="John Smith"
                name="name"
                onChange={nameChangeHandler}
                value={name}
              />
            </Grid>
            <Grid item md={5.5} xs={12}>
              <label htmlFor="company">Company</label>
              <input
                className={styles.input}
                placeholder="John Smith Ltd"
                name="company"
                onChange={companyChangeHandler}
                value={company}
              />
            </Grid>
            <Grid item md={5.5} xs={12}>
              <label htmlFor="email">Email*</label>
              <input
                className={styles.input}
                placeholder="johnsmith@gmail.com"
                name="email"
                type="email"
                onChange={emailChangeHandler}
                value={email}
              />
            </Grid>
            <Grid item md={5.5} xs={12}>
              <label htmlFor="mobile">Mobile*</label>
              <input
                className={styles.input}
                placeholder="07400000000"
                name="mobile"
                type="tel"
                onChange={mobileChangeHandler}
                value={mobile}
              />
            </Grid>
            <Grid item xs={12}>
              <label htmlFor="project-details">Project Details*</label>
              <textarea
                className={styles.input}
                placeholder="Description of project i.e. volume, dimensions, colour and deadline"
                name="project-details"
                rows={8}
                onChange={detailsChangeHandler}
                value={details}
              />
            </Grid>
            <Grid item xs={12}>
              <button
                className={styles["edit-button"]}
                style={{ width: "10rem", marginRight: "10px" }}
                onClick={formSubmitHandler}
                id="project"
              >
                Submit
              </button>
              <button
                className={styles["edit-button"]}
                onClick={formResetHandler}
                id="project"
              >
                Reset
              </button>
              <br />
              <Typography>{errorMessage}</Typography>
            </Grid>
          </Grid>
        ) : modal === "Chat" ? (
          <Grid
            sx={{
              backgroundColor: "white",
              width: { xs: "95vw", sm: "38rem" },
              height: { xs: "46rem", sm: "40rem" },
              display: "flex",
              justifyContent: "space-between",
              // alignItems: "center",
              color: "black",
              py: { sm: 5, xs: 2 },
              px: { sm: 8, xs: 4 },
              position: "relative",
            }}
            container
          >
            <button
              style={{
                position: "absolute",
                right: "3rem",
                backgroundColor: "transparent",
                border: "none",
                cursor: "pointer",
                top: "3rem",
              }}
              onClick={handleClose}
            >
              <ClearIcon />
            </button>
            <Grid item xs={12}>
              <Typography component="h2" variant="h4">
                Let's chat
              </Typography>
            </Grid>
            <Grid item md={5.5} xs={12}>
              <label htmlFor="name">Full Name*</label>
              <input
                className={styles.input}
                placeholder="John Smith"
                name="name"
                onChange={nameChangeHandler}
                value={name}
              />
            </Grid>
            <Grid item md={5.5} xs={12}>
              <label htmlFor="company">Company/Club Name*</label>
              <input
                className={styles.input}
                placeholder="John Smith Ltd"
                name="company"
                onChange={companyChangeHandler}
                value={company}
              />
            </Grid>
            <Grid item md={5.5} xs={12}>
              <label htmlFor="email">Email*</label>
              <input
                className={styles.input}
                placeholder="johnsmith@gmail.com"
                name="email"
                type="email"
                onChange={emailChangeHandler}
                value={email}
              />
            </Grid>
            <Grid item md={5.5} xs={12}>
              <label htmlFor="mobile">Mobile*</label>
              <input
                className={styles.input}
                placeholder="07400000000"
                name="mobile"
                type="tel"
                onChange={mobileChangeHandler}
                value={mobile}
              />
            </Grid>
            <Grid item xs={12}>
              <label htmlFor="project-details">Enquiry*</label>
              <textarea
                className={styles.input}
                placeholder="Description of project/enquiry"
                name="project-details"
                rows={8}
                onChange={detailsChangeHandler}
                value={details}
              />
            </Grid>
            <Grid item xs={12}>
              <button
                className={styles["edit-button"]}
                style={{ width: "10rem", marginRight: "10px" }}
                onClick={formSubmitHandler}
                id="project"
              >
                Submit
              </button>
              <button
                className={styles["edit-button"]}
                onClick={formResetHandler}
                id="project"
              >
                Reset
              </button>
              <br />
              <Typography>{errorMessage}</Typography>
            </Grid>
          </Grid>
        ) : (
          ""
        )}
      </Backdrop>
      <Box sx={{ width: "100%", height: "calc( 100vh - 6rem )" }}>
        <Fade
          onChange={function noRefCheck() {}}
          onStartChange={function noRefCheck() {}}
          indicators={indicators}
          {...properties}
          duration={4000}
          transitionDuration={800}
        >
          {slider &&
            slider.map((slide: any) => (
              <Grid
                container
                sx={{
                  position: "relative",
                  color: "white",
                  height: "calc( 100vh - 6rem )",
                  width: "100%",
                }}
              >
                {slide.get("image") && (
                  <img
                    src={slide.get("image").url()}
                    alt="banner"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      zIndex: -5,
                      height: "calc( 100vh - 6rem )",
                      width: "100%",
                    }}
                  />
                )}
                {/* <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    zIndex: -1,
                    height: "30rem",
                    width: "100%",
                    backgroundColor: "black",
                    opacity: 0.5,
                  }}
                ></Box> */}

                <Typography
                  component="h2"
                  variant="h3"
                  sx={{ position: "absolute", left: "7rem", bottom: "3rem" }}
                >
                  {slide.get("title")}
                </Typography>
              </Grid>
            ))}
        </Fade>
      </Box>
      <Box
        sx={{
          width: "100%",
          position: "relative",
          height: { md: "70rem", xs: "110rem" },
        }}
      >
        <Container>
          <Grid
            container
            sx={{ display: "flex", justifyContent: "space-between", mt: 10 }}
          >
            <Grid item md={5.7} xs={12}>
              <motion.div
                variants={textVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
              >
                <Typography component="h2" variant="h4">
                  Sport Memorabilia
                </Typography>
                <br />
                <Typography sx={{ fontStyle: "italic" }}>
                  Get inspired by our innovative approach to mounting and
                  framing sports memorabilia.
                </Typography>
                <br />
                <Typography>
                  Driven by a passion for innovation and creativity, our team of
                  specialists has developed a unique method for mounting
                  shirts—addressing one of the biggest challenges in sports
                  memorabilia framing. Traditionally, many framers worldwide pin
                  or tag the corners of a folded shirt to secure it onto a
                  substrate, while others use a cardboard template for shaping
                  before mounting. Although widely practiced, these methods are
                  far from ideal, as they often lead to fabric sagging and
                  stretching over time. This not only damages the shirt but also
                  diminishes its original beauty once framed.
                  <br />
                  After years of research and experimentation, our specialists
                  have developed an archival-grade approach to shirt mounting
                  that ensures both long-term preservation and enhanced
                  presentation. Our method includes:
                  <br />
                  <br />
                  • Custom foam board templating for a precise fit <br />•
                  Gentle stretching and secure fixing of the shirt to the
                  template <br />
                  • Attaching the shirt to a premium substrate (such as mount
                  board or suede fabric)
                  <br />
                  <br />
                  This technique fully stretches the shirt, providing a stable
                  structure for framing while enhancing its visual appeal. The
                  added thickness from proper mounting creates a premium
                  display, eliminating the need for ironing. This is
                  particularly crucial for autographed shirts, as signatures
                  made with ethanol- and isopropanol-based markers can fade or
                  discolor under high heat.
                  <br />
                  <br />
                  With our innovative approach, we ensure that your sports
                  memorabilia remains beautifully preserved for years to come.
                </Typography>
              </motion.div>
            </Grid>
            <Grid item md={5.5} xs={12}>
              {" "}
              <motion.div
                variants={shirtVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
              >
                <img src={enland} alt="England" style={{ width: "100%" }} />
              </motion.div>
            </Grid>
          </Grid>
        </Container>
        <img
          src={collage}
          alt="collage"
          style={{
            width: "100%",
            position: "absolute",
            bottom: 0,
            zIndex: "-1",
            opacity: 0.6,
          }}
        />
      </Box>
      <Box sx={{ width: "100%", backgroundColor: "black", color: "white" }}>
        <Grid
          container
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Grid item md={6} xs={12}>
            <Box sx={{ ml: { lg: "calc( 55vw - 42rem )", xs: 2 }, py: 4 }}>
              {" "}
              <motion.div
                variants={textVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
              >
                <Typography component="h2" variant="h4">
                  CMC Technology
                </Typography>
                <br />
                <br />
                <Typography sx={{ fontStyle: "italic" }} variant="h6">
                  Exploring beyond imagination - Taking advantage of todays
                  cutting-edge CMC technology.
                </Typography>
                <br />
                <Typography sx={{ fontStyle: "italic" }}>
                  Offering both custom layouts and prototyping as wells as
                  volume mount cutting service
                </Typography>
                <br />
                <button
                  className={styles.button}
                  onClick={handleOpen}
                  id="CMC Project"
                >
                  Get in touch
                </button>
              </motion.div>
            </Box>
          </Grid>
          <Grid item md={5} xs={12}>
            <video src={cmc} style={{ width: "100%" }} autoPlay loop />
          </Grid>
        </Grid>
      </Box>
      <Container sx={{ py: 5 }}>
        <Typography component="h2" variant="h4" sx={{ display: "inline" }}>
          Limitation to our approach –
        </Typography>{" "}
        <Typography
          component="h2"
          variant="h4"
          sx={{ display: "inline", fontStyle: "italic" }}
        >
          None!
        </Typography>{" "}
        <Typography
          component="h2"
          variant="h6"
          sx={{ display: "inline", fontStyle: "italic" }}
        >
          Only your imagination
        </Typography>
        <br />
        <br />
        <Typography variant="subtitle1">
          Let's explore few case studies together to better appreciate the
          application of our technique when it comes to mounting challenging or
          damaged shirts
        </Typography>
        <br />
        <CaseStudyTab />
        <Typography component="h2" variant="h4" sx={{ mt: 7 }}>
          Album
        </Typography>
        <br />
        <Typography>
          Explore a handpicked selection of our previously framed works.
        </Typography>
        <br />
        <MemorabiliaAlbumTab />
        <Typography component="h2" variant="h4" sx={{ mt: 15 }}>
          Military Medals
        </Typography>
        <br />
        <Typography>
          Our team was honored to have immortalized the memories of many
          ex-military personnel and brave soldiers. We are delighted to showcase
          a selection of these here for you to explore and be inspired by.
        </Typography>
        <br />
      </Container>
      {military && (
        <Box sx={{ position: "relative" }}>
          <Container>
            <Album album={military} albumArray={militaryArray} />
          </Container>
          <img
            src={collageLight}
            alt="collage light"
            style={{
              width: "100%",
              position: "absolute",
              bottom: "0",
              zIndex: "-1",
            }}
          />
        </Box>
      )}
      <Box sx={{ width: "100%", backgroundColor: "#f2f2f2", py: 8 }}>
        <Container>
          <Grid
            container
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Grid item xs={12} md={3.5}>
              {" "}
              <motion.div
                variants={textVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
              >
                <Typography component="h2" variant="h4">
                  Our Clients
                </Typography>
                <br />
                <Typography>
                  We are honoured to have collaborated with numerous UK football
                  and rugby teams, as well as their passionate supporters.
                  <br />
                  <br /> Are you a club, interesting in working with us?{" "}
                  <button
                    style={{
                      backgroundColor: "transparent",
                      outline: "none",
                      border: "none",
                      textDecoration: "underline",
                      cursor: "pointer",
                      padding: "0",
                    }}
                    id="Chat"
                    onClick={handleOpen}
                  >
                    Let’s chat
                  </button>
                </Typography>
              </motion.div>
            </Grid>
            <Grid
              item
              xs={12}
              md={5}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                my: { xs: 8, md: 0 },
              }}
            >
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={1}
              >
                <Typography
                  sx={{ color: "#7f7f7f", pl: 3 }}
                  component="h2"
                  variant="h4"
                >
                  Football Clients
                </Typography>
                <img
                  src={footballTeams}
                  alt="football teams"
                  style={{ width: "100%" }}
                />
              </motion.div>
            </Grid>
            <Grid
              item
              xs={12}
              md={3}
              sx={{
                alignSelf: "start",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={2}
              >
                <Typography
                  sx={{ color: "#7f7f7f", pl: 3 }}
                  component="h2"
                  variant="h4"
                >
                  Rugby Clients
                </Typography>
                <img
                  src={rugbyTeams}
                  alt="rugby teams"
                  style={{ width: "100%", maxWidth: "20rem" }}
                />
              </motion.div>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Grid
        sx={{
          backgroundColor: "white",
          width: { xs: "100%", sm: "40rem" },
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: "black",
          // py: 5,
          px: 8,
          m: "0 auto",
          gap: 3,
          mt: 10,
          mb: 10,
        }}
        container
      >
        <Grid item xs={12}>
          <Typography component="h2" variant="h4">
            Start Your Framing Journey Now
          </Typography>
          <br />
        </Grid>
        <Grid item xs={12} md={5.5}>
          <label htmlFor="name">Full Name*</label>
          <input
            className={styles.input}
            placeholder="John Smith"
            name="name"
            onChange={nameChangeHandler}
            value={name}
          />
        </Grid>
        <Grid item xs={12} md={5.5}>
          <label htmlFor="company">Company (Optional)</label>
          <input
            className={styles.input}
            placeholder="John Smith Ltd"
            name="company"
            onChange={companyChangeHandler}
            value={company}
          />
        </Grid>
        <Grid item xs={12} md={5.5}>
          <label htmlFor="email">Email*</label>
          <input
            className={styles.input}
            placeholder="johnsmith@gmail.com"
            name="email"
            type="email"
            onChange={emailChangeHandler}
            value={email}
          />
        </Grid>
        <Grid item xs={12} md={5.5}>
          <label htmlFor="mobile">Mobile*</label>
          <input
            className={styles.input}
            placeholder="07400000000"
            name="mobile"
            type="tel"
            onChange={mobileChangeHandler}
            value={mobile}
          />
        </Grid>
        <Grid item xs={12} md={5.5}>
          <FormControl fullWidth>
            <label htmlFor="mobile">Memorabilia Type*</label>
            <CustomeSelect
              id="demo-simple-select"
              value={memorabiliaType}
              onChange={memorabiliaTypeChangeHandler}
              fullWidth
              displayEmpty
              multiple
              renderValue={(selected: any) => {
                if (selected.length === 0) {
                  return <span style={{ color: "#757575" }}> Choose one</span>;
                }

                return selected;
              }}
            >
              <ListSubheader>Sport Memorabilia:</ListSubheader>
              <MenuItem value={"Football/Rugby Shirt"}>
                Football/Rugby Shirt
              </MenuItem>
              <MenuItem value={"Boxing Gloves"}>Boxing Gloves</MenuItem>
              <MenuItem value={"Rackets Signed Balls"}>
                Rackets Signed Balls
              </MenuItem>
              <MenuItem value={"Race Bibs/Medals"}>Race Bibs/Medals</MenuItem>
              <MenuItem value={"Sports Boots/Cleats"}>
                Sports Boots/Cleats
              </MenuItem>
              <MenuItem value={"Cricket Bats"}>Cricket Bats</MenuItem>
              <MenuItem value={"Hockey Sticks"}>Hockey Sticks</MenuItem>
              <MenuItem value={"Motorsport Gear"}>Motorsport Gear</MenuItem>
              <MenuItem value={"Caps/Hats"}>Caps/Hats</MenuItem>
              <ListSubheader>Music Memorabilia:</ListSubheader>
              <MenuItem value={"Signed Vinyl Records/CDs"}>
                Signed Vinyl Records/CDs
              </MenuItem>
              <MenuItem value={"Concert Posters/Tickets"}>
                Concert Posters/Tickets
              </MenuItem>
              <MenuItem value={"Signed Guitars/Drumsticks"}>
                Signed Guitars/Drumsticks
              </MenuItem>
              <MenuItem value={"Film/Theatre Props"}>
                Film/Theatre Props
              </MenuItem>
              <MenuItem value={"Music Sheets /Setlists"}>
                Music Sheets /Setlists
              </MenuItem>
              <ListSubheader>Historical & Military Memorabilia:</ListSubheader>
              <MenuItem value={"Medals/Badges"}>Medals/Badges</MenuItem>
              <MenuItem value={"Military Uniforms"}>Military Uniforms</MenuItem>
              <MenuItem value={"Historical Documents/Letters"}>
                Historical Documents/Letters
              </MenuItem>
              <MenuItem value={"Maps"}>Maps</MenuItem>
              <MenuItem value={"Certificates"}>Certificates</MenuItem>
              <ListSubheader>Event Memorabilia:</ListSubheader>
              <MenuItem value={"Wedding Bouquets/Invitations"}>
                Wedding Bouquets/Invitations
              </MenuItem>
              <MenuItem value={"Baby Clothes/Keepsakes"}>
                Baby Clothes/Keepsakes
              </MenuItem>
              <MenuItem value={"Graduation Caps/Certificates"}>
                Graduation Caps/Certificates
              </MenuItem>
              <MenuItem value={"Festiva/Event Wristbands"}>
                Festiva/Event Wristbands
              </MenuItem>
              <ListSubheader>Fashion & Pop Culture Memorabilia:</ListSubheader>
              <MenuItem value={"Designer Scarves"}>Designer Scarves</MenuItem>
              <MenuItem value={"Accessories"}>Accessories</MenuItem>
              <MenuItem value={"Celebrity-Worn Clothing"}>
                Celebrity-Worn Clothing
              </MenuItem>
              <MenuItem value={"Vintage Magazine Covers"}>
                Vintage Magazine Covers
              </MenuItem>
            </CustomeSelect>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <label htmlFor="project-details">Framing Project*</label>
          <textarea
            className={styles.input}
            placeholder="Description of project i.e. volume, dimensions, colour and deadline"
            name="project-details"
            rows={12}
            onChange={detailsChangeHandler}
            value={details}
          />
        </Grid>

        <Grid item xs={12}>
          <button
            className={styles["edit-button"]}
            style={{ width: "10rem", marginRight: "10px" }}
            onClick={formSubmitHandler}
            id="project"
          >
            Submit
          </button>
          <button
            className={styles["edit-button"]}
            onClick={formResetHandler}
            id="project"
          >
            Reset
          </button>
          <br />
          <Typography>{errorMessage}</Typography>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default Memorabilia;
